import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Camera } from 'types/camera';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseLinkedCamerasOptions = UseQueryOptions<
  OffsetPaginated<Camera>,
  APIError
> & {
  params?: OffsetPaginationParams;
};

export function useLinkedCameras(
  gatewayId: string | null | undefined,
  {
    queryKey = ['cameras', 'linked'],
    params,
    enabled,
    ...options
  }: UseLinkedCamerasOptions = {}
) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      if (!gatewayId) {
        return Promise.reject('No gateway id provided.');
      }

      const { data } = await client.get(
        `/apps/${applicationID}/gateways/${gatewayId}/linked_cameras`,
        { params: queryParams }
      );

      return data;
    },
    {
      ...options,
      enabled:
        enabled !== undefined
          ? Boolean(gatewayId)
          : Boolean(gatewayId) && enabled,
    }
  );
}
